export default __webpack_public_path__ + "static/media/bgEllipse3.fdaa4d5f.svg";